import React, { useState, useEffect } from "react";
import "./LoginLogs.css";
import { apiRequest } from "./api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const LoginLogs = ({ onClose }) => {
  const [loginLogs, setLoginLogs] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const recordsPerPage = 25;
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedLog, setSelectedLog] = useState(null);

  useEffect(() => {
    const fetchLoginLogs = async () => {
      try {
        const response = await apiRequest(
          `/api/login_logs/?search=${searchTerm}&page=${page}&limit=${recordsPerPage}`
        );
        const data = await response.json();
        setLoginLogs(data.results);
        setTotalPages(data.totalPages);
        setTotalRecords(data.total);
      } catch (error) {
        console.error("Błąd podczas pobierania logów logowań:", error);
      }
    };
    fetchLoginLogs();
  }, [searchTerm, page]);

  const handleShowDetails = (log) => {
    setSelectedLog(log);
  };

  const handleHideDetails = () => {
    setSelectedLog(null);
  };

  const renderPaginationButtons = () => {
    const buttons = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(1, page - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    // Przycisk "Poprzednia"
    if (page > 1) {
      buttons.push(
        <button
          key="prev"
          onClick={() => setPage(page - 1)}
          className="pagination-btn"
        >
          Poprzednia
        </button>
      );
    }

    // Przyciski numerów stron
    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={i}
          onClick={() => setPage(i)}
          className={`pagination-btn ${i === page ? "active" : ""}`}
        >
          {i}
        </button>
      );
    }

    // Przycisk "Następna"
    if (page < totalPages) {
      buttons.push(
        <button
          key="next"
          onClick={() => setPage(page + 1)}
          className="pagination-btn"
        >
          Następna
        </button>
      );
    }

    return buttons;
  };

  return (
    <div className="login-logs-page">
      <div className="login-logs-header">
        <h2>Rejestr logowań i wylogowań</h2>
        <button onClick={onClose} className="close-btn">
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </div>

      <div className="login-logs-search">
        <input
          type="text"
          placeholder="Szukaj po email, IP, akcji lub przyczynie błędu..."
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setPage(1);
          }}
          className="search-input"
        />
      </div>

      <div className="login-logs-info">
        <p>Znaleziono {totalRecords} rekordów</p>
      </div>

      <div className="login-logs-table-container">
        <table className="login-logs-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Email</th>
              <th>Data/Godzina</th>
              <th>IP</th>
              <th>Akcja</th>
              <th>Status</th>
              <th>Przyczyna błędu</th>
              <th>Akcje</th>
            </tr>
          </thead>
          <tbody>
            {loginLogs.map((log) => (
              <tr key={log.id}>
                <td>{log.id}</td>
                <td>{log.email}</td>
                <td>{log.login_time}</td>
                <td>{log.ip_address || "Brak"}</td>
                <td>
                  <span className={`action ${log.action === 'LOGIN' ? 'login' : 'logout'}`}>
                    {log.action === 'LOGIN' ? 'Logowanie' : 'Wylogowanie'}
                  </span>
                </td>
                <td>
                  <span className={`status ${log.success === 'Y' ? 'success' : 'error'}`}>
                    {log.success === 'Y' ? 'Sukces' : 'Błąd'}
                  </span>
                </td>
                <td>{log.failure_reason || "Brak"}</td>
                <td>
                  <button
                    onClick={() => handleShowDetails(log)}
                    className="details-btn"
                  >
                    Szczegóły
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="pagination">
          {renderPaginationButtons()}
        </div>
      )}

      {selectedLog && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h3>Szczegóły {selectedLog.action === 'LOGIN' ? 'logowania' : 'wylogowania'}</h3>
              <button onClick={handleHideDetails} className="close-btn">
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="modal-body">
              <div className="detail-row">
                <strong>ID:</strong> {selectedLog.id}
              </div>
              <div className="detail-row">
                <strong>Email:</strong> {selectedLog.email}
              </div>
              <div className="detail-row">
                <strong>Data/Godzina:</strong> {selectedLog.login_time}
              </div>
              <div className="detail-row">
                <strong>Adres IP:</strong> {selectedLog.ip_address || "Brak"}
              </div>
              <div className="detail-row">
                <strong>Akcja:</strong> 
                <span className={`action ${selectedLog.action === 'LOGIN' ? 'login' : 'logout'}`}>
                  {selectedLog.action === 'LOGIN' ? 'Logowanie' : 'Wylogowanie'}
                </span>
              </div>
              <div className="detail-row">
                <strong>User Agent:</strong> {selectedLog.user_agent || "Brak"}
              </div>
              <div className="detail-row">
                <strong>Status:</strong> 
                <span className={`status ${selectedLog.success === 'Y' ? 'success' : 'error'}`}>
                  {selectedLog.success === 'Y' ? 'Sukces' : 'Błąd'}
                </span>
              </div>
              {selectedLog.failure_reason && (
                <div className="detail-row">
                  <strong>Przyczyna błędu:</strong> {selectedLog.failure_reason}
                </div>
              )}
              <div className="detail-row">
                <strong>Utworzono:</strong> {selectedLog.created_at}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginLogs;